// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBoxFormik_checkbox__bKnM-"};